import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Star } from 'lucide-react';
import useBasket from '../../hooks/basket/useBasket';
import useCashbackProgram from '../../hooks/cashback/useCashbackProgram';

export default function ExpectedCashback() {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Cashback:ExpectedCashback' });
  const { total } = useBasket();
  const { hasCashbackProgram, calculateExpectedCashback } = useCashbackProgram();

  const expectedCashback = useMemo(() => calculateExpectedCashback(total), [total, calculateExpectedCashback]);

  if (!hasCashbackProgram || expectedCashback <= 0) {
    return null;
  }

  return (
    <span className="text-brand-primary flex gap-xs items-center text-sm">
      <Star className="size-4 fill-brand-primary text-brand-primary" />
      <span>
        <Trans
          t={t}
          values={{ value: expectedCashback }}
          components={{
            highlight: <span className="font-semibold" />,
          }}
        >
          text
        </Trans>
      </span>
    </span>
  );
}
